import {
  SET_LEAVE_DAYS,
  FETCH_LEAVE_DAYS,
  FETCH_LEAVE_DAYS_SUCCESS,
  FETCH_LEAVE_DAYS_FAILURE,
} from "./actionTypes"

export const setLeaveDays = leaveDays => ({
  type: SET_LEAVE_DAYS,
  payload: leaveDays,
})
// console.log("leavedays",leaveDays);

export const fetchLeaveDays = () => ({
  type: FETCH_LEAVE_DAYS,
  // payload: leaveDays,
})

export const fetchLeaveDaysSuccess = leaveDays => ({
  type: FETCH_LEAVE_DAYS_SUCCESS,
  payload: leaveDays,
})

export const fetchLeaveDaysFailure = error => ({
  type: FETCH_LEAVE_DAYS_FAILURE,
  payload: error,
})

// Think of payload as the box of information you are sending.

// The box (payload) contains: ["2025-05-15", "2025-05-20"]

// You are sending it with a label: "SET_LEAVE_DAYS"
